import { colors, fontSize, fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const nav = css`
  display: inline-flex;
  color: ${colors.gray[10]};
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.bold};
  height: 54px;
  align-items: center;
  border-bottom: 4px solid ${colors.gray[6]};
  width: 100%;

  & > svg {
    width: ${fontSize.sm};
    height: ${fontSize.sm};
    margin: 0 10px 0 20px;
  }
`;
